import { BreadcrumbsPlaceholder } from '../BreadcrumbsPlaceholder';
import { CurrentItemGalleryPlaceholder } from './CurrentItemGalleryPalceholder';
import { CurrentItemHeaderPlaceholder } from './CurrentItemHeaderPlaceholder';
import { CurrentItemTitlePlaceholder } from './CurrentItemTitlePlaceholder';
import {
  CurrentItemPlaceholderContent,
  CurrentItemPlaceholderLayout,
  CurrentItemSection,
  DescriptionPlaceholder,
  MapPlaceholder,
  LocationsPlaceholder,
  StatisticPlaceholder,
  MainInfoPlaceholder,
  ManagementPlaceholder
} from './styled';

export const CurrentItemPlaceholder = () => {
  return (
    <CurrentItemPlaceholderLayout>
      <CurrentItemHeaderPlaceholder />
      <BreadcrumbsPlaceholder />
      <CurrentItemTitlePlaceholder />

      <CurrentItemPlaceholderContent>
        <div>
          <CurrentItemGalleryPlaceholder />

          <CurrentItemSection>
            <DescriptionPlaceholder
              height="52px"
              margin="0"
              borderRadius="14px"
            />
            <MapPlaceholder height="52px" margin="0" borderRadius="14px" />
            <LocationsPlaceholder
              height="52px"
              margin="0"
              borderRadius="14px"
            />
            <StatisticPlaceholder
              height="52px"
              margin="0"
              borderRadius="14px"
            />
          </CurrentItemSection>
        </div>

        <CurrentItemSection>
          <MainInfoPlaceholder height="52px" margin="0" borderRadius="14px" />
          <ManagementPlaceholder
            height="221px"
            margin="0"
            borderRadius="14px"
          />
        </CurrentItemSection>
      </CurrentItemPlaceholderContent>
    </CurrentItemPlaceholderLayout>
  );
};
